'use client';

import {useState} from 'react';

type Props = {
  email: string;
  label: string;
};

export default function MailTo({email, label}: Props) {
  const [visible, setVisible] = useState(false);

  return (
    <span className="inline text-primary">
      {visible ? (
        <a href={`mailto:${email}`}>{email}</a>
      ) : (
        <button className="select-text" onClick={() => setVisible(true)}>
          {label}
        </button>
      )}
    </span>
  );
}
